/**
 * "Tells: …" — who an action notifies, shown before the button that does it.
 *
 * Keep each line in step with backend-python/services/notification_catalog.py,
 * which is the record of what every action actually sends.
 */
import { Caption1, tokens } from '@fluentui/react-components'
import { Mail16Regular } from '@fluentui/react-icons'

const CHANNEL = { email: 'email + in app', app: 'in app only' } as const

export function ToldLine({
  children,
  channel,
}: {
  children: React.ReactNode
  /** How it arrives; omit when nobody is told. */
  channel?: keyof typeof CHANNEL
}) {
  return (
    <Caption1
      data-testid="told-line"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        color: tokens.colorNeutralForeground3,
      }}
    >
      <Mail16Regular aria-hidden />
      <span>
        Tells: {children}
        {channel && ` · ${CHANNEL[channel]}`}
      </span>
    </Caption1>
  )
}
